import { render } from "./AnnouncingPage.vue?vue&type=template&id=c07e8588&scoped=true"
import script from "./AnnouncingPage.vue?vue&type=script&lang=js"
export * from "./AnnouncingPage.vue?vue&type=script&lang=js"

import "./AnnouncingPage.vue?vue&type=style&index=0&id=c07e8588&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07e8588"]])

export default __exports__